import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { AdminLayout } from "@/components/admin/AdminLayout";
import HomePage from "./pages/HomePage";
import PropertiesPage from "./pages/PropertiesPage";
import PropertyDetailsPage from "./pages/PropertyDetailsPage";
import AuthPage from "./pages/admin/AuthPage";
import DashboardPage from "./pages/admin/DashboardPage";
import AdminPropertiesPage from "./pages/admin/AdminPropertiesPage";
import PropertyFormPage from "./pages/admin/PropertyFormPage";
import LeadsPage from "./pages/admin/LeadsPage";
import SettingsPage from "./pages/admin/SettingsPage";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/imoveis" element={<PropertiesPage />} />
            <Route path="/imoveis/:slug" element={<PropertyDetailsPage />} />
          </Route>
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AuthPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="imoveis" element={<AdminPropertiesPage />} />
            <Route path="imoveis/:id" element={<PropertyFormPage />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="configuracoes" element={<SettingsPage />} />
          </Route>
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
